import React from "react";

// Icon components
const EmailIcon = ({ size = 20, color }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2">
    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
    <polyline points="22,6 12,13 2,6" />
  </svg>
);

const RecoverForm = ({ errors, fieldFocus, setFieldFocus, colors }) => {
  return (
    <div className="flex flex-col gap-4">
      <div>
        <label
          htmlFor="email"
          className="block text-sm font-semibold mb-1.5"
          style={{ 
            color: fieldFocus.email ? colors.primary : colors.text 
          }}
        >
          Email
        </label>
        <div
          className="flex items-center rounded-xl px-4 h-14 border transition-all"
          style={{
            backgroundColor: colors.card,
            borderColor: errors.email 
              ? colors.error 
              : fieldFocus.email 
                ? colors.primary 
                : 'transparent',
            borderWidth: '1.5px',
          }}
        >
          <EmailIcon 
            size={20} 
            color={fieldFocus.email ? colors.primary : colors.secondary} 
          />
          <input
            autoFocus
            required
            id="email"
            name="email"
            type="email"
            placeholder="Enter your email address"
            className="flex-1 ml-3 bg-transparent outline-none text-base"
            style={{ 
              color: colors.text,
            }}
            onFocus={() => setFieldFocus(prev => ({ ...prev, email: true }))}
            onBlur={() => setFieldFocus(prev => ({ ...prev, email: false }))}
          />
        </div>
        {errors.email && (
          <div className="text-xs mt-1.5 ml-1" style={{ color: colors.error }}>
            {errors.email}
          </div>
        )}
      </div>
    </div>
  );
};

export default RecoverForm;
